(function () {
	const headingAnimation = () => {
		const headings = document.querySelectorAll('.js-split-text');

		const splitHeadings = () => {
			const split = new SplitType(
				document.querySelectorAll('.js-split-text p'),
			);
			headings.forEach((heading) => {
				heading.classList.add('visible');
			});
		};

		const animateLines = (lines) => {
			lines.forEach((line, i) => {
				line.classList.add('animated');
				Array.from(line.children).forEach((element) => {
					element.style.animationDelay = `${i * 0.3}s`;

					setTimeout(() => {
						line.style.overflow = 'visible';
					}, 400 * (i + 1));
				});
			});
		};

		const headingObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const lines = entry.target.querySelectorAll('.line:not(.testimonials__slide-text .line)');
						animateLines(lines);
						headingObserver.unobserve(entry.target);
					}
				});
			},
			{
				rootMargin: "0px 0px -100px 0px"
			},
		);

		const resizeObserver = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				const lines = entry.target.querySelectorAll('.line:not(.testimonials__slide-text .line)');
				splitHeadings(lines);
				animateLines(lines);
				headings.forEach((heading) => {
					headingObserver.observe(heading);
				});
			});
		});

		splitHeadings();
		headings.forEach((heading) => {
			headingObserver.observe(heading);
			resizeObserver.observe(heading);
		});
	};

	document.addEventListener('shopify:section:load', headingAnimation);

	// Start once the DOM and the headings' fonts are ready, instead of waiting for window 'load'
	// (which waits for every image and third-party script and delayed LCP on mobile).
	// Fonts must be loaded first so SplitType breaks lines exactly as before.
	let started = false;
	const start = () => {
		if (started) return;
		started = true;
		headingAnimation();
	};

	const loadHeadingFonts = () => {
		if (!document.fonts || !document.fonts.load) return Promise.resolve();
		const fonts = new Set();
		document.querySelectorAll('.js-split-text, .js-split-text *').forEach((el) => {
			const cs = getComputedStyle(el);
			fonts.add(`${cs.fontStyle} ${cs.fontWeight} 16px ${cs.fontFamily}`);
		});
		return Promise.all([...fonts].map((font) => document.fonts.load(font).catch(() => {})));
	};

	const startWhenReady = () => {
		const timeout = new Promise((resolve) => setTimeout(resolve, 3000));
		Promise.race([loadHeadingFonts(), timeout]).then(start);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', startWhenReady);
	} else {
		startWhenReady();
	}

	window.addEventListener('load', start);
})();
